__webpack_require__.p = "https://catalog-frontend.guildeducation.com/";